class Quiz extends HTMLElement {
    constructor() {
        super();
        this.setQuizzData();
        this.querySelectorAll('.next-step-button').forEach((item) => {
            if (this.isFinalStep) item.addEventListener('click', this.handleLastStep.bind(this));
            else item.addEventListener('click', this.handleNextPreviousStepButtons.bind(this));
        });

        this.querySelectorAll('.previous-step-button').forEach((item) => {
            item.addEventListener('click', this.handleNextPreviousStepButtons.bind(this));
        });

        if (this.isFinalStep && document.getElementById('quiz-contact')) {
            this.quizContactContainer = document.getElementById('quiz-contact');
            this.ajaxifyAndDisplayForm();
        }

        if (this.step <= 1) history.pushState({ currentStep: this.step }, `Step ${this.step}`, this.dataset.stepurl);
    }
    handleLastStep(e) {
        e.preventDefault();
        this.setChoice(e.currentTarget);
        document.querySelector('progress').value = 100;
        this.querySelector('.final-step-container').classList.add('tw-opacity-0');
        this.querySelector('.final-step-container').classList.add('tw-h-[650px]');
        this.querySelector('.results-wrapper').classList.remove('tw-opacity-0');
        this.querySelector('.results-wrapper').classList.remove('tw-z-10');
        this.querySelector('.results-wrapper').classList.add('tw-z-1');

        if (this.quizContactContainer) {
            this.quizContactContainer.classList.remove('hidden');
            this.bindDataToForm();
        } else {
            this.hideProgressShowResults();
        }
        localStorage.removeItem('quiz_manager');
        this.renderResults();

    }
    handleNextPreviousStepButtons(e) {
        // Unrelated to wether the transition is supported or no
        const clickedAnchorTag = e.currentTarget;
        const goingForward = clickedAnchorTag.classList.contains('next-step-button');
        if (goingForward) {
            this.setChoice(clickedAnchorTag);
            localStorage.setItem('quiz_manager', JSON.stringify(this.quizManager));
        }

        const viewTransitionApiNotSupported = !document.startViewTransition;
        const lastStepAndGoingBackButton = this.step <= 1 && !goingForward;
        if (viewTransitionApiNotSupported || lastStepAndGoingBackButton) return;

        e.preventDefault();

        var disablePushingToHistory = false;
        var goinToTransitionToFirstStep = this.step - 1 <= 1;
        if (!goingForward && goinToTransitionToFirstStep) {
            // First step push state is in constructor
            disablePushingToHistory = true;
        }

        const href = clickedAnchorTag.getAttribute('href');
        this.transitionPage(href, disablePushingToHistory);
    }
    transitionPage(href, disablePushingToHistory = false) {
        const transition = document.startViewTransition(() => {
            fetch(href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');
                    const newContent = doc.querySelector('.quiz-wrapper');
                    const currentContent = document.querySelector('.quiz-wrapper');

                    // Add the easing class to the new conten

                    // Replace the current content with the new content
                    currentContent.replaceWith(newContent);

                    if (!disablePushingToHistory) {
                        history.pushState({ currentStep: this.step }, `Step ${this.step + 1}`, href);
                    }
                });
        });

        transition.ready.then(() => {
            // Animate the root’s new view
        });
    }
    ajaxifyAndDisplayForm() {
        const form = this.quizContactContainer.querySelector('form');
        form.addEventListener('submit', (event) => {
            event.stopPropagation();
            event.preventDefault();

            const form = event.target;
            const formData = new FormData(form);
            const action = form.getAttribute('action');
            fetch(action, {
                method: 'POST',
                body: formData,
            })
                .then((response) => {
                    if (response.ok) {
                        this.quizContactContainer.classList.add('hidden');
                        this.hideProgressShowResults();
                        return;
                    }
                    throw new Error('Network response was not ok.');
                })
                .catch((error) => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        });
    }
    renderResults() {
        this.getRecommendedProduct().then(async (items) => {

            const results = []
            for await (const product of items) {
                const link = `${product.link}`
                const description = product.description;
                const img = product.shopify_images[0];
                const title = product.title
                results.push({ product: { link, description, img, title } });
            }

            const productHtml = results.map(({ product }) => {
                return `
                    <div class="product">
                        <a href="${product.link}">
                           <h2>${product.title}</h2>
                            <img src="${product.img}" alt="${product.title}">
                        </a>
                     
                    </div>
                `;
            }).join('');

            // for await (const product of items) {
            //     const cleanedUrl = `/${product.link}`
            //     const url = `https://${Shopify.shop}` + cleanedUrl + "?view=data";
            //     const recommendedResponse = await fetch(url);
            //     const recommendedText = await recommendedResponse.text();
            //     const parser = new DOMParser();
            //     const doc = parser.parseFromString(recommendedText, 'text/html');
            //     const recommendedResults = doc.querySelector('header.product-title');
            //     results.push({ product: recommendedResults.innerHTML });
            // }

            var algoliasearch = window.algolia.externals.algoliasearch;

            var client = algoliasearch(
                window.algolia.config.app_id,
                window.algolia.config.search_api_key
            );

            var index_suffix = window.algolia.config.index_suffix;
            var index = client.initIndex(window.algolia.config.index_prefix + 'products' + index_suffix);

            // Perform a search and return JSON results
            index.search('your-query-here').then(function (response) {
                console.log(response.hits); // Outputs JSON results
            }).catch(function (err) {
                console.error(err);
            });

            // const mergedObject = results.map(i => i.product)
            document.querySelector('.results').innerHTML = `<ul class="brand_grid">${productHtml}</ul>`;
        });
    }
    hideProgressShowResults() {
        // document.querySelector('progress').classList.add('hidden');
        this.querySelector('.results-container').classList.remove('tw-hidden');
    }
    setQuizzData() {
        this.quizManager = localStorage.getItem('quiz_manager');

        if (!this.quizManager) this.quizManager = {};
        else this.quizManager = JSON.parse(this.quizManager);

        const { step, quiz, final } = this.dataset;
        if (final) this.isFinalStep = true;
        if (!this.quizManager[quiz]) this.quizManager[quiz] = {};
        this.step = step;
        this.quiz = quiz;
    }
    setChoice(htmlAnchorTagClicked) {
        const { choiceValue } = htmlAnchorTagClicked.dataset;
        if (choiceValue) this.quizManager[this.quiz][this.step] = choiceValue;
    }
    getData() {
        return [...new Set(Object.values(this.quizManager[this.quiz]))];
    }
    bindDataToForm() {
        const input = this.quizContactContainer.querySelector('[name="contact[tags]"]');
        if (!input) return;
        input.value = this.getData().join(',');
    }
    async getRecommendedProduct() {
        let searchTerm = this.getData().join(' + ');
        console.log(searchTerm)

        const query = `https://searchserverapi.com/getwidgets?api_key=7H1P3c3Z5h&q=${searchTerm}&maxResults=3&startIndex=0&items=true&pages=true&facets=false&categories=true&suggestions=true&vendors=false&tags=false&pageStartIndex=0&pagesMaxResults=3&categoryStartIndex=0&categoriesMaxResults=3&suggestionsMaxResults=4&vendorsMaxResults=3&tagsMaxResults=3&output=jsonp`

        const response = await fetch(
            query
        );

        const searchResult = await response.json();
        console.log(searchResult)
        if (searchResult.items.length) {
            return searchResult.items;
        }


        // const response = await fetch(
        //     `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`
        // );
        // const suggestions = await response.json();
        // if (suggestions.resources.results.products.length) {
        //     return suggestions.resources.results.products;
        // }
    }
}
customElements.define('quiz-step', Quiz);

const handleBrowserBackButtonWithinQuiz = () => {
    const quizStep = document.querySelector('quiz-step');
    const newURL = document.location.href;
    var disablePushingToHistory = true;
    quizStep.transitionPage(newURL, disablePushingToHistory);
};
window.addEventListener('popstate', handleBrowserBackButtonWithinQuiz);